import { CourseDtoLandingPage, UserDto, Workshop } from "@rinastyling/common";
import { Routes } from "./clientRoutes";

export interface NewRouteInfo {
  text: string;
  href?: Routes | string;
  subRoutes?: NewRouteInfo[];
}
export const getMainNavbarRoutes = ({
  workshop,
  user,
  courses
}: {
  workshop: Workshop | null;
  user?: UserDto;
  courses: CourseDtoLandingPage[];
}) => {
  const navbarRoutes: (NewRouteInfo | null)[] = [
    user?.isAdmin
      ? { text: "עמוד הבית אדמין", href: Routes.adminHomePage }
      : null,
    { text: "עמוד הבית", href: Routes.home },
    !user ? { text: "להתחברות", href: Routes.login } : null,
    {
      text: "קורסים אונליין",
      subRoutes: courses.map((course) => ({
        text: course.name,
        href: Routes.courseLandingPage.replace(":id", course.id)
      }))
    },
    {
      text: "שירותי סטייילינג",
      subRoutes: [
        { text: "ליווי שופינג", href: Routes.shoopingEscort },
        { text: "ייעוץ סטיילינג עד הבית", href: Routes.personalStylingToHome },
        { text: "סדנאות קבוצתיות", href: Routes.groupStyling },
        { text: "סטיילינג קבוצתי", href: Routes.groupStylingLessons }
      ]
    },
    { text: "חנות פופאפ", href: Routes.popupStore },
    workshop ? { text: workshop?.title, href: Routes.openWorkshop } : null,
    user ? { text: "לפרופיל שלי", href: Routes.profile } : null
  ];

  return navbarRoutes.filter(Boolean) as NewRouteInfo[];
};

export const adminNavbarRoutes: NewRouteInfo[] = [
  { text: "עמוד הבית אדמין", href: Routes.adminHomePage },
  { text: "עורך טקסט", href: Routes.adminTextEditor },
  { text: "מנהל קודי קופון", href: Routes.couponCodeManager },
  { text: "ניהול קורס", href: Routes.courseDashboard },
  { text: "דאשבורד מתעניינים", href: Routes.intrestedManager },
  { text: "ניהול חנות", href: Routes.adminStoreManager },
  { text: "ניהול קבצים", href: Routes.adminOpenAssetManager },
  { text: "ניהול משתמשים", href: Routes.adminUsersManager },
  { text: "ניהול סדנאות", href: Routes.adminWorkshopManager },
  { text: "שליחת מיילים למשתמשים", href: Routes.adminEmailSender },
  { text: "יצירת עמוד נחיתה", href: Routes.adminCustomLandingCreator }
];
